import { render } from "./CYWNvirtualCommerce.vue?vue&type=template&id=bc89daa4&scoped=true"
import script from "./CYWNvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./CYWNvirtualCommerce.vue?vue&type=script&lang=js"

import "./CYWNvirtualCommerce.vue?vue&type=style&index=0&id=bc89daa4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bc89daa4"

export default script